import { createContext, useContext, useEffect, useState } from 'react';

// Fail-open defaults: if the flags endpoint hasn't responded yet (or errors out),
// every step behaves exactly as it does today.
const initialState = {
    kycStep: true,
    aaStep: true,
    bankStep: true,
    selfieStep: true,
    videoDeclarationStep: true,
    addressProofStep: true,
    addressGeoMatch: true
};

const FeatureFlagsContext = createContext(initialState);

const API_URL = process.env.REACT_APP_API_URL || '';

export function FeatureFlagsProvider({ children }) {
    const [flags, setFlags] = useState(initialState);

    useEffect(() => {
        fetch(`${API_URL}/api/config/feature-flags`)
            .then(r => r.json())
            .then(data => {
                if (data.success && data.flags) {
                    setFlags(prev => ({ ...prev, ...data.flags }));
                }
            })
            .catch(err => console.error('Error loading feature flags:', err));
    }, []);

    return <FeatureFlagsContext.Provider value={flags}>{children}</FeatureFlagsContext.Provider>;
}

export function useFeatureFlags() {
    return useContext(FeatureFlagsContext);
}
